<div class="form-dialog">
  <h2 mat-dialog-title class="dialog-title">
    Assign Form
    <span class="close-icon" (click)="onCancel()">
      <i class="fas fa-times"></i>
    </span>
  </h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="dialog-content">
      <div class="form-group">
        <label class="field-label">Form Type</label>
        <div class="field-input">
          <ng-select formControlName="formType"
                   [items]="data.formTypes"
                   [searchable]="false"
                   [clearable]="false"
                   class="frm-ng-select"
                   bindLabel="form_name"
                   placeholder="Select form type">
          </ng-select>
          <div class="error" *ngIf="form.get('formType').invalid && form.get('formType').touched">
            Please select a form type
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="field-label">Assign To</label>
        <div class="field-input">
          <ng-select formControlName="assignedTo"
                   [items]="data.users"
                   [searchable]="true"
                   [clearable]="false"
                   bindLabel="name"
                   bindValue="id"
                   class="frm-ng-select"
                   placeholder="Select team member">
          </ng-select>
          <div class="error" *ngIf="form.get('assignedTo').invalid && form.get('assignedTo').touched">
            Please select a team member
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="field-label">Due Date</label>
        <div class="field-input">
          <mat-form-field appearance="none" class="new-frm-input">
            <input matInput [matDatepicker]="picker" formControlName="dueDate"
                   placeholder="Select due date (optional)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button type="button" class="btn-secondary" (click)="onCancel()">
        Cancel
      </button>
      <button type="submit" class="btn-publish" [disabled]="!form.valid">
        Assign Form
      </button>
    </mat-dialog-actions>
  </form>
</div>
